import { toAbsoluteUrl } from "../../_metronic/helpers";
import { DictionaryModel } from "./DictionaryModel";

export interface IUserModel {
  id: string,
  firstName: string,
  lastName: string,
  email: string,
  emailConfirmed: boolean,
  phoneNumber: string,
  phoneNumberConfirmed: boolean,
  password: string,
  passwordValid?: string,
  isActive?: boolean,
  createdAt?: Date,
  modifiedAt?: Date,
  userName?: string,
  roles?: Array<string>
  permissions?: Array<string>
  details?: Array<DictionaryModel>
  photo: string
}

const userInitValues: IUserModel = {
  id: '',
  firstName: '',
  lastName: '',
  password: '',
  passwordValid: '',
  email: '',
  emailConfirmed: false,
  isActive: false,
  phoneNumber: '',
  phoneNumberConfirmed: false,
  //createdAt: new Date(),
  //modifiedAt: new Date(),
  details: [],
  permissions: [],
  roles: [],
  userName: '',
  photo: toAbsoluteUrl('/media/avatars/blank.png'),
}

export { userInitValues }
